import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { useTranslations } from "next-intl";
import concat from "lodash/concat";
import range from "lodash/range";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { DropdownWrapper, InfoIcon } from "./AgeDropdown.styles";
import { DEFAULT_AGE } from "../context";
var AgeDropdown = function(param) {
    var value = param.value, label = param.label, onChange = param.onChange;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    var ref = useState(value < 26 || value > 65), showDropdown = ref[0], setShowDropdown = ref[1];
    var ageDropdownData = concat(range(18, 26).map(function(item) {
        return {
            label: item.toString(),
            value: item.toString()
        };
    }), {
        label: t("age.defaultAge"),
        value: DEFAULT_AGE.toString()
    }, range(66, 100).map(function(item) {
        return {
            label: item.toString(),
            value: item.toString()
        };
    }));
    var handleChange = function(event) {
        var age = Number(event.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(age);
    };
    return /*#__PURE__*/ _jsxs(DropdownWrapper, {
        children: [
            showDropdown ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        htmlFor: "customerAge",
                        children: t("age.select.label")
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Dropdown, {
                        id: "customerAge",
                        value: value,
                        options: ageDropdownData,
                        onChange: handleChange
                    })
                ]
            }) : /*#__PURE__*/ _jsx(UiLegacy.Checkbox, {
                id: "driverIsAdult",
                label: label,
                checked: true,
                onChange: function() {
                    return setShowDropdown(!showDropdown);
                }
            }),
            /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(UiLegacy.Tooltip, {
                    content: /*#__PURE__*/ _jsx(UiLegacy.Markup, {
                        content: t("age.tooltip.text")
                    }),
                    trigger: /*#__PURE__*/ _jsx(InfoIcon, {})
                })
            })
        ]
    });
};
export { AgeDropdown };
